export default __webpack_public_path__ + "static/toolscover-11e203a795e3d6a3794fe4884bbc5730.png";